import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useActiveChatEntities from '../../../hooks/plugins/chat/useActiveChatEntities';
import useChatConnectionState from '../../../hooks/plugins/chat/useChatConnectionState';
import { isTicketsPage } from '../../../utils/routeHelper';
import { getPluginStore } from '../../../utils/store/getStore';

function ActiveChatTabsController({ children, tabs }) {
    const { asPath } = useRouter();
    const { connectedToChat } = useChatConnectionState();

    const { data } = useActiveChatEntities({ requestFlag: connectedToChat });
    useEffect(() => {
        isTicketsPage(asPath) && connectedToChat && data && getPluginStore().setActiveChatEntities(data);
    }, [asPath, connectedToChat, data, tabs?.length]);

    return <>{children}</>;
}
export default observer(ActiveChatTabsController);
